import { useState, useEffect, useMemo } from "react";
import { pricesService } from "../dependencyInjection";
import { PricesGroup } from "../services/PricesService";
import { unsubscribe } from "../../../../utils";

type UseUserResult = [PricesGroup[], boolean];

export function usePrices(): UseUserResult {
  const [prices, setPrices] = useState<PricesGroup[]>([]);
  const [pendind, setPending] = useState(false);
  useEffect(() => {
    const subPrices = pricesService.prices$.subscribe((pricesData) => {
      setPrices(pricesData);
    });
    const subLoading = pricesService.loading$.subscribe((loading) => {
      setPending(loading);
    });
    return unsubscribe(subPrices, subLoading);
  }, []);

  const getPrices = useMemo(
    () => async () => {
      try {
        await pricesService.getPrices();
      } catch (e) {}
    },
    [],
  );

  useEffect(() => {
    getPrices();
  }, [getPrices]);

  return [prices, pendind];
}
